import type { SVGProps } from 'react';

type AgentsTitleIconProps = SVGProps<SVGSVGElement>;

/** Figma 4193:77564 — 20×20 agent face in the Agents page title. */
export function AgentsTitleIcon({
  width = 20,
  height = 20,
  className,
  ...props
}: AgentsTitleIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M2.5 13.3333V6.66667C2.5 4.36548 4.36548 2.5 6.66667 2.5H13.3333C15.6345 2.5 17.5 4.36548 17.5 6.66667V13.3333C17.5 15.6345 15.6345 17.5 13.3333 17.5H6.66667C4.36548 17.5 2.5 15.6345 2.5 13.3333Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        d="M13.75 12.0781C13.75 12.0781 12.5 13.7448 10 13.7448C7.5 13.7448 6.25 12.0781 6.25 12.0781"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08464 8.33333C6.85452 8.33333 6.66797 8.14678 6.66797 7.91667C6.66797 7.68655 6.85452 7.5 7.08464 7.5C7.31475 7.5 7.5013 7.68655 7.5013 7.91667C7.5013 8.14678 7.31475 8.33333 7.08464 8.33333Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9167 8.33333C12.6866 8.33333 12.5 8.14678 12.5 7.91667C12.5 7.68655 12.6866 7.5 12.9167 7.5C13.1467 7.5 13.3333 7.68655 13.3333 7.91667C13.3333 8.14678 13.1467 8.33333 12.9167 8.33333Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
